// import React, { useState, useEffect } from 'react';
import { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Register from './pages/Register';
import PrivateRoute from './components/PrivateRoute';
import Collections from './pages/Collections';
import CollectionDetail from './pages/CollectionDetail';
import GameDetail from './pages/GameDetail';
import Users from './pages/Users';
import Profile from './pages/Profile';
import Feedback from './pages/Feedback';
import AdminRoute from './components/AdminRoute';
import AdminFeedback from './pages/admin/AdminFeedback';
import AdminUsers from './pages/admin/AdminUsers';
import AdminCollections from './pages/admin/AdminCollections';
import AdminGames from './pages/admin/AdminGames';
import LandingPage from './pages/LandingPage';

export default function App() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    return savedMode ? JSON.parse(savedMode) : false;
  });

  useEffect(() => {
    const root = window.document.documentElement;
    if (isDarkMode) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode((prevMode: boolean) => !prevMode);
  };

  return (
    <NotificationProvider>
      <AuthProvider>
        <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
          <Navbar />
          <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/collections" element={
                <PrivateRoute>
                  <Collections />
                </PrivateRoute>
              } />
              
              <Route
                path="/collections/:collectionId"
                element={
                  <PrivateRoute>
                    <CollectionDetail />
                  </PrivateRoute>
                }
              />
              
              <Route
                path="/games/:gameId"
                element={
                  <PrivateRoute>
                    <GameDetail />
                  </PrivateRoute>
                }
              />
              
              <Route
                path="/users"
                element={
                  <PrivateRoute>
                    <Users />
                  </PrivateRoute>
                }
              />
              
              {/* Remove Friends Route */}
              {/* 
              <Route
                path="/friends"
                element={
                  <PrivateRoute>
                    <Friends />
                  </PrivateRoute>
                }
              />
              */}
              
              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <Profile isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
                  </PrivateRoute>
                }
              />

              {/* Add Feedback Route */}
              <Route
                path="/feedback"
                element={
                  <PrivateRoute>
                    <Feedback />
                  </PrivateRoute>
                }
              />

              {/* Admin Routes */}
              <Route 
                path="/admin/feedback" 
                element={
                  <AdminRoute>
                    <AdminFeedback />
                  </AdminRoute>
                }
              />
              <Route 
                path="/admin/users" 
                element={
                  <AdminRoute>
                    <AdminUsers />
                  </AdminRoute>
                }
              />
              {/* Add Admin Collections Route */}
              <Route 
                path="/admin/collections" 
                element={
                  <AdminRoute>
                    <AdminCollections />
                  </AdminRoute>
                }
              />
               {/* Add Admin Games Route */}
              <Route 
                path="/admin/games" 
                element={
                  <AdminRoute>
                    <AdminGames />
                  </AdminRoute>
                }
              />
              {/* Admin Dashboard Route */}
              <Route 
                path="/admin"
                element={
                  <AdminRoute>
                    <div className="p-6 card">
                      <h1 className="text-2xl font-bold dark:text-white">Admin Dashboard</h1>
                      <p className="dark:text-gray-300 mt-2">Admin sections:</p>
                      <ul className="list-disc list-inside dark:text-gray-300 mt-2">
                        <li><a href="/admin/feedback" className="text-primary hover:underline">View Feedback</a></li>
                        <li><a href="/admin/users" className="text-primary hover:underline">View Users</a></li> 
                        <li><a href="/admin/collections" className="text-primary hover:underline">View Collections</a></li>
                        <li><a href="/admin/games" className="text-primary hover:underline">View Games</a></li>
                        {/* Add links to other admin pages */} 
                      </ul>
                    </div>
                  </AdminRoute>
                }
              />

            </Routes>
          </main>
        </div>
      </AuthProvider>
    </NotificationProvider>
  );
} 